import React from 'react'; 
import { Row, Col, Card } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlay, faShareAlt, faClock } from '@fortawesome/free-solid-svg-icons'
import { COLORS } from '../utils/Constants';

const cardWidth = window.innerWidth-32;
const boxHeight = cardWidth*3/5;

const TileMobile = React.memo(props => {
    
    let displayMovieObj = props.displayMovieObj;
    let index = props.index;      
    let uploadId = props.uploadId;  

    return (
        <Row style={{ margin: 16, marginBottom: 16 }}>
            <Col span={24} offset={0} style={{ display: 'flex', justifyContent: 'center' }}>
                <Card className="customCard"
                    style={{ width: '100%', margin: 0, padding: 0, backgroundColor: COLORS.blue2a3a4a }}
                >
                    <div>
                        <div onClick={() => { props.openPlayer(uploadId, index, props.movieObj) }} 
                        style={{ cursor: 'pointer', flexDirection: 'column', position:'absolute', width:'100%', height: boxHeight, 
                        display:'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <div style={{ width:'100%', height:'100%', display:'flex', justifyContent: 'center', alignItems: 'center', 
                            transition: 'background-color 100ms linear', backgroundColor: null }}>
                                <FontAwesomeIcon className='playButton' icon={faPlay} style={{ position: 'absolute', opacity: 0.7, color: COLORS.eeeWhite, fontSize: 40 }} 
                                />
                                <div style={{ marginTop: 100 }}>
                                    <p className='watchTrailer' style={{ fontFamily: 'OpenSans-Bold', opacity: 0.7, color: COLORS.eeeWhite }}>{ '' }</p>
                                </div>
                            </div>
                        </div>
                        <div style={{ width: '100%' }}>
                        <img src={displayMovieObj.portriatImage} alt={displayMovieObj.movieName} style={{  width: '100%' }} />
                        </div>
                        <div style={{ margin: 8 }}>
                            <div style={{ display:'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <p style={{ width: cardWidth-50, textAlign: 'center', overflowWrap: 'break-word', whiteSpace: 'break-spaces', fontSize: '17px', fontFamily: 'OpenSans-Bold', 
                                color: COLORS.yellow, lineHeight: 1.4, margin: 8, marginBottom: 0 }}>
                                    {displayMovieObj.movieName+'\n'} 
                                    <p style={{ fontSize: '12px', fontFamily: 'OpenSans-Bold', color: COLORS.lightBlue, lineHeight: 1.5, margin: 8 }}>
                                    {'Release: '+props.releaseDateTimeString+' Hrs\n'}{props.expiryString} 
                                    </p>
                                </p>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: 16 }}>
                                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                                            <div style={{ width: 48 }}>
                                                <img src={props.ratingImage} alt={displayMovieObj.rating} style={{ width: 32, height: 32, margin: 8 }} />
                                            </div>
                                            <div style={{ width: 48, display: 'flex', flexDirection: 'column' }}>
                                                    <FontAwesomeIcon color={COLORS.lightBlue} icon={faClock} 
                                                    style={{ cursor: 'pointer', fontSize: 24, margin: '12px', marginBottom: 0 }} />
                                                <div>
                                                    <p style={{ whiteSpace: 'pre', width: 48, position: 'absolute', fontSize: 12, fontFamily: 'OpenSans-Bold', color: COLORS.lightBlue, textAlign: 'center', marginTop: 0, lineHeight: 2 }}>
                                                        {displayMovieObj.duration}
                                                    </p>
                                                </div>
                                            </div>
                                            <FontAwesomeIcon onClick={() => { props.shareUrl(displayMovieObj.sharedUrl, index) }} color={COLORS.lightBlue} icon={faShareAlt} 
                                            style={{ cursor: 'pointer', fontSize: 24, marginLeft: 15, margin: '12px' }} />
                                        </div>
                                        <div style={{ position: 'absolute', width: 200, top: -20, right: 0, display: 'flex', justifyContent: 'center' }}>
                                            <p style={{ fontSize: 12, fontFamily: 'OpenSans-Bold', color: COLORS.yellow }}>
                                                {props.linkText}
                                            </p>
                                        </div>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'center' }} onClick={() => { props.buyButton(index, props.movieObj, props.showPrice) }}>
                                <div>
                                { props.button }
                                </div>
                            </div>
                        </div>
                    </div>               
                </Card>
            </Col>
        </Row>
    );
});
  
export default TileMobile;